import { ButtonBase, Fade, Modal as MuiModal, Stack } from "@mui/material"
import closeIcon from "../../assets/icons/close.png"
import Title from "./Title"
import { colors } from "../../services/config/colors"
import { defaultBoxShadow } from "../../services/config/constants"
import { useTranslation } from "react-i18next"
import { ReactNode } from "react"

const Modal = ({
  open,
  handleClose,
  title,
  children,
}: {
  open: boolean
  handleClose: () => void
  title: string
  children?: ReactNode
}) => {
  const { t } = useTranslation()

  return (
    <MuiModal
      open={open}
      onClose={handleClose}
      aria-labelledby={title}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Fade in={open}>
        <Stack
          gap={4}
          style={{
            backgroundColor: colors.backgroundWhite,
            width: "calc(100% - 44px)",
            maxWidth: 550,
            height: "auto",
            maxHeight: "90vh",
            overflowY: "scroll",
            borderRadius: 16,
            paddingInline: 24,
            paddingBottom: 38,
            paddingTop: 38,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            position: "relative",
          }}
        >
          <ButtonBase
            style={{
              position: "absolute",
              top: 16,
              right: 16,
              width: 36,
              height: 36,
              borderRadius: 18,
              backgroundColor: colors.backgroundWhite,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: defaultBoxShadow,
            }}
            onClick={handleClose}
            aria-label={t("close")}
          >
            <img src={closeIcon} style={{ width: 10, height: 10 }} alt="" />
          </ButtonBase>
          <Title
            id={title}
            fontWeight={600}
            lineHeight="32px"
            textAlign="center"
            paddingLeft={28}
            paddingRight={28}
          >
            {title}
          </Title>
          {children}
        </Stack>
      </Fade>
    </MuiModal>
  )
}

export default Modal
